import { z } from "zod";

export const SupportCasesOptionSchema = z.object({
  Id: z.string(),
  Name: z.string().optional(),
});

export type SupportCasesOptionType = z.infer<typeof SupportCasesOptionSchema>;
